
import { address } from '~/util/string'

export default {
    props: {
        model: {
            type: Object,
            default: null
        },
        prefix: {
            type: String,
            default: ''
        },
    },
    computed: {
        address () {
            return address(this.model, this.prefix)
        },
    },
}
